import {
  ALLOWED_OUTREACH_RADIUS_MILES,
  V1SnapshotOutreachRadius,
} from '@factoryfixinc/ats-interfaces';

export const DEFAULT_OUTREACH_RADIUS_MILES: V1SnapshotOutreachRadius =
  V1SnapshotOutreachRadius.THIRTY;

export const OUTREACH_RADIUS_HELPER_TEXT = [
  'Controls how far from the job location your AI recruiter will source passive candidates.',
  'Smaller radii can reduce commute mismatches, especially for hourly roles.',
  "Doesn't affect inbound applicants.",
].join(' ');

export function isOutreachRadiusOption(value: unknown): value is V1SnapshotOutreachRadius {
  return (
    typeof value === 'number' &&
    (ALLOWED_OUTREACH_RADIUS_MILES as readonly number[]).includes(value)
  );
}
